<template>
  <div class="subflow">
    <div v-if="auction && auction.type != 't3marketplace'"> 
      <VAuctionFormControls
      ref="auctionForm"
      :car="auction"
      class="pb-3"
      @success="onSubmitAuctionForm"
      :changeAuctionStartDate="changeAuctionStartDate"
      :changeAuctionEndDate="changeAuctionEndDate"
    />
    </div>
   

    <TheSellCarForm 
      v-if="showForm" 
      :car="auction"
      :startDate="startDate"
      :endDate="endDate"
      @success="onSubmitCarForm"
    />
  </div>
</template>
<script>
import TheSellCarForm from '../SellCarForm/TheSellCarForm'
import VAuctionFormControls from './VAuctionFormControls'
import {
  createAuctionManagerMixin,
  auctionManagerStore
} from '@/mixins/auctionsManagerMixin'
export default {
  name: 'VAuctionForm',
  mixins: [createAuctionManagerMixin()],

  components: {
    TheSellCarForm,
    VAuctionFormControls
  },

  props: {
    auction: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    formData: {},
    showForm: false,
    auctionForm: {},
    startDate: '',
    endDate: ''
  }),

  watch: {
    show(v) {
      if (!v) {
        setTimeout(() => {
          this.showForm = v
        }, 500)
      } else {
        this.showForm = v
      }
    }
  },

  methods: {
    changeAuctionStartDate(date){
      this.startDate = date
    },
    changeAuctionEndDate(date){
      this.endDate = date
    },
    async onSubmitCarForm() {
      if (this.$refs.auctionForm) {
        await this.$refs.auctionForm.saveDates()
      }

      this.showModalAndClose()
    },

    onSubmitAuctionForm () {
      this.showModalAndClose()
    },

    async showModalAndClose() {
      const modalSuccess = {
        title: 'Updated successfully',
        body: `Car <strong>${this.auction.title}</strong> was updated`
      }
      this.$modals.open(modalSuccess)
      setTimeout(() => {
        this.$modals.close()
        // window.location.reload()
      }, 3000)
    },

    onInputCarDetails (v) {
      this.formData = v
    }
  }
}
</script>
